package com.downdogapp.client.controllers

import com.downdogapp.client.MANIFEST
import com.downdogapp.client.ViewController
import com.downdogapp.client.controllers.start.StartViewController
import com.downdogapp.client.singleton.App
import com.downdogapp.client.views.WelcomeView

class WelcomeViewController(private val onSignInSuccess: () -> Unit = {}) : ViewController() {

  override val view = WelcomeView(this)

  override fun onBackClicked() {
    App.exit()
  }

  fun onSignUpClicked() {
    fun pushSignIn() {
      App.pushViewController(
        SignInViewController(
          isSignUp = true,
          titleLabel = MANIFEST.signUpTitle,
          subtitleLabel = MANIFEST.signUpSubtitle,
          onSuccess = onSignInSuccess
        )
      )
    }
    if (MANIFEST.onboardingConfig?.showBeforeLogin == true) {
      StartViewController.promptOnboarding {
        pushSignIn()
      }
    } else {
      pushSignIn()
    }
  }

  fun onLogInClicked() {
    App.pushViewController(
      SignInViewController(
        isSignUp = false,
        titleLabel = null,
        subtitleLabel = null,
        onSuccess = onSignInSuccess
      )
    )
  }
}
